export function gtmViewVideo(categoria: string, tipo: string, nome: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "view_video",
    video: {
      categoria_video: categoria,
      tipo_video: tipo,
      nome_video: nome,
    },
  });
}

export function gtmPlayVideo(categoria: string, tipo: string, nome: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "play_video",
    video: {
      categoria_video: categoria,
      tipo_video: tipo,
      nome_video: nome,
    },
  });
}

export function gtmFinishVideo(categoria: string, tipo: string, nome: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "finish_video",
    video: {
      categoria_video: categoria,
      tipo_video: tipo,
      nome_video: nome,
    },
  });
}
